import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './Carousel.css';
import img1 from "./img/img-1.webp";
import img2 from "./img/img-2.webp";
import img3 from "./img/img-3.jpg";

const sliderList = [
    { id: 1, src: img1, alt: 'img-1' },
    { id: 2, src: img2, alt: 'img-2' },
    { id: 3, src: img3, alt: 'img-3' },
];

const Carousel = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 10000
    };

    return (
        <Slider {...settings}>
            {sliderList.map((image) => (
                <div key={image.id} className="slider-thumbnail">
                    <img src={image.src} alt={image.alt} />
                </div>
            ))}
        </Slider>
    );
};

export default Carousel;
